;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"

// Was MUI IconButton + @mui/icons-material; now plain Tailwind + inline chevron
// (renders on the initial home page, so kept off MUI/Emotion).
function RightPageButtonIcon({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Right"
      className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-solid border-[#C4C4C4] text-[#092C3C] transition-colors hover:bg-black/5"
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M9 6l6 6-6 6"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}
export default RightPageButtonIcon
